import { useEffect } from 'react';

import { useAiDataPolicyStore } from './store';

const MIN_GAP_MS = 5000;

let polling: (() => void) | null = null;

export function startAiDataPolicyPolling(intervalMs: number): () => void {
  if (polling) return polling;
  let last = Date.now();
  const refresh = () => {
    if (document.visibilityState !== 'visible') return;
    const now = Date.now();
    if (now - last < MIN_GAP_MS) return;
    last = now;
    void useAiDataPolicyStore.getState().load();
  };
  const id = window.setInterval(refresh, intervalMs);
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', refresh);
  polling = () => {
    window.clearInterval(id);
    window.removeEventListener('focus', refresh);
    document.removeEventListener('visibilitychange', refresh);
    polling = null;
  };
  return polling;
}

export function useAiDataPolicyLiveRefresh(intervalMs: number, enabled = true): void {
  useEffect(() => {
    if (!enabled) return;
    let last = 0;
    const refresh = () => {
      const now = Date.now();
      if (now - last < MIN_GAP_MS) return;
      last = now;
      void useAiDataPolicyStore.getState().load();
    };
    const onVisible = () => {
      if (document.visibilityState === 'visible') refresh();
    };
    refresh();
    const id = window.setInterval(refresh, intervalMs);
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.clearInterval(id);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [intervalMs, enabled]);
}
